<script setup>
import { useProjectionModelBackend } from '../composables/useProjectionModelBackend'

defineProps({
  compact: { type: Boolean, default: false },
})

const { backend, setBackend } = useProjectionModelBackend()
</script>

<template>
  <div class="backend-toggle" :class="{ compact }">
    <span class="backend-toggle-label">Model API</span>
    <div class="backend-toggle-group" role="group" aria-label="Projection model API">
      <button
        type="button"
        :class="{ active: backend === 'ocdev2' }"
        title="oct's V25 release served on this VM (isolated v25-ocdev2 containers)"
        @click="setBackend('ocdev2')"
      >
        V25 · ocdev2
      </button>
    </div>
    <small v-if="!compact">Uses V25 on this VM (isolated containers)</small>
  </div>
</template>

<style scoped>
.backend-toggle {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 168px;
}
.backend-toggle.compact {
  min-width: 0;
}
.backend-toggle-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5b6470;
}
.backend-toggle-group {
  display: flex;
  border: 1px solid #cfd6de;
  border-radius: 999px;
  overflow: hidden;
  background: #fff;
}
.backend-toggle-group button {
  flex: 1;
  border: 0;
  background: transparent;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #5b6470;
  cursor: pointer;
}
.backend-toggle-group button.active {
  background: #4338ca;
  color: #fff;
}
.backend-toggle small {
  color: #7a8490;
  font-size: 11px;
}
</style>
